<!-- 权益活动H5-奖品列表 -->
<template>
  <div class="right-activity-prize">
    <div class="prize-header">
      <span class="prize-title">我的权益</span>
      <span class="prize-count" v-if="total">共{{ total }}件</span>
    </div>
    <div class="prize-scroll">
      <van-pull-refresh v-model="refreshing" @refresh="refresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length ? '没有更多了' : ''"
          :immediate-check="false"
          @load="loadList"
        >
          <div class="prize-card" v-for="item in list" :key="item.id">
            <div class="card-main">
              <div class="cover">
                <img v-if="coverUrl(item)" :src="coverUrl(item)" />
                <van-icon v-else name="gift-o" />
              </div>
              <div class="info">
                <div class="name">{{ item.goodsName || '权益奖品' }}</div>
                <div class="meta">
                  <span class="num">x{{ item.num || 1 }}</span>
                  <span class="status" :class="`status-${item.receiveStatus}`">
                    {{ statusTextMap[item.receiveStatus] || '未知状态' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="card-foot">
              <span class="time" :class="{ 'receiving-tip': item.receiveStatus === 3 }">{{ footTimeText(item) }}</span>
              <button
                class="btn"
                :class="isReceiveNotStarted(item) ? 'btn-disabled' : 'btn-primary'"
                v-if="item.receiveStatus === 0 || item.receiveStatus === 2"
                :disabled="receivingId === item.id || isReceiveNotStarted(item)"
                @click="receive(item)"
              >{{ receiveBtnText(item) }}</button>
              <button
                class="btn btn-plain"
                v-else-if="item.receiveStatus === 1"
                @click="openDetail(item)"
              >去绑定</button>
              <button class="btn btn-disabled" v-else disabled>领取中</button>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <div class="empty" v-if="!list.length && finished">
        <van-icon name="gift-o" />
        <p>暂无可领取的权益</p>
      </div>
    </div>
    <PrizeDetail :visible.sync="detailVisible" :prize="currentPrize" />
  </div>
</template>
<script>
import { orderPages, receiveOrder } from '@/api/rightActivityH5'
import PrizeDetail from './PrizeDetail.vue'

const PAGE_SIZE = 10

export default {
  name: 'RightActivityPrizeList',
  components: { PrizeDetail },
  data() {
    return {
      list: [],
      total: 0,
      pageNum: 1,
      loading: false,
      finished: false,
      refreshing: false,
      receivingId: null,
      detailVisible: false,
      currentPrize: {},
      statusTextMap: {
        0: '待领取',
        1: '已领取',
        2: '领取失败',
        3: '领取中',
      },
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    coverUrl(item) {
      const url = item.gcCoverUrl || item.gcMainUrl || ''
      return url.replace(/^http:/, '')
    },
    // 尚未到领取开始时间
    isReceiveNotStarted(item) {
      if (!item || !item.receiveStartTime) return false
      const start = new Date(String(item.receiveStartTime).replace(/-/g, '/')).getTime()
      if (Number.isNaN(start)) return false
      return Date.now() < start
    },
    footTimeText(item) {
      if (item.receiveStatus === 3) return '五秒后手动刷新页面查看领取结果'
      if (item.receiveTime) return `领取时间 ${item.receiveTime}`
      if (this.isReceiveNotStarted(item)) return `领取开始时间 ${item.receiveStartTime}`
      return '尚未领取'
    },
    receiveBtnText(item) {
      if (this.isReceiveNotStarted(item)) return '未到领取时间'
      return item.receiveStatus === 2 ? '重新领取' : '立即领取'
    },
    // 分页查询奖品
    loadList() {
      this.loading = true
      orderPages({
        pageNum: this.pageNum,
        pageSize: PAGE_SIZE,
        param: {},
      }).then(res => {
        this.loading = false
        this.refreshing = false
        if (this.checkExpired(res)) return
        if (res.code !== 0) {
          this.finished = true
          return this.$toast.fail(res.message || '权益列表加载失败')
        }
        const data = res.data || {}
        const records = data.records || []
        this.list = this.pageNum === 1 ? records : this.list.concat(records)
        this.total = data.total || 0
        this.pageNum += 1
        this.finished = !records.length || this.list.length >= this.total
      }).catch(() => {
        this.loading = false
        this.refreshing = false
        this.finished = true
      })
    },
    refresh() {
      this.pageNum = 1
      this.finished = false
      this.loadList()
    },
    // 领取奖品
    receive(item) {
      if (this.isReceiveNotStarted(item)) return
      if (this.receivingId) return
      this.receivingId = item.id
      receiveOrder(item.id).then(res => {
        this.receivingId = null
        if (this.checkExpired(res)) return
        if (res.code !== 0) return this.$toast.fail(res.message || '领取失败，请稍后重试')
        this.$toast.success('领取成功')
        this.refresh()
      }).catch(() => {
        this.receivingId = null
      })
    },
    openDetail(item) {
      this.currentPrize = item
      this.detailVisible = true
    },
    // 登录态失效交由父级处理
    checkExpired(res) {
      if (res && (res.code === 403 || res.code === 401)) {
        this.$emit('expired')
        return true
      }
      return false
    },
  },
}
</script>
<style lang="less">
/* bank rootValue=37.5，本项目=75，样式 px 按 2 倍书写以对齐视觉尺寸 */
.right-activity-prize {
  flex: 1;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .prize-header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 24px;
    padding: 0 8px;
    flex: none;
  }
  .prize-title {
    font-size: 36px;
    font-weight: 600;
    color: #1f2d4d;
  }
  .prize-count {
    flex: none;
    font-size: 26px;
    color: #8a93a6;
  }
  .prize-scroll {
    flex: 1;
    height: 0;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    .van-pull-refresh {
      min-height: 100%;
      overflow: visible;
    }
  }
  .prize-card {
    margin-bottom: 24px;
    padding: 24px;
    border-radius: 28px;
    background: #fff;
    box-shadow: 0 8px 32px rgba(31, 45, 77, 0.08);
    .card-main {
      display: flex;
      align-items: center;
    }
    .card-foot {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 24px;
      padding-top: 20px;
      border-top: 1px dashed #ebedf2;
    }
    .time {
      flex: 1;
      min-width: 0;
      padding-right: 20px;
      font-size: 24px;
      color: #8a93a6;
      line-height: 1.4;
    }
    .receiving-tip {
      color: #3d7eff;
    }
    .cover {
      flex: none;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 128px;
      height: 128px;
      border-radius: 20px;
      background: #f5f6fa;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .van-icon {
        font-size: 52px;
        color: #c3c8d4;
      }
    }
    .info {
      flex: 1;
      min-width: 0;
      padding: 0 20px;
    }
    .name {
      font-size: 30px;
      font-weight: 500;
      color: #1f2d4d;
      line-height: 1.4;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .meta {
      display: flex;
      align-items: center;
      margin-top: 16px;
      font-size: 24px;
      color: #8a93a6;
    }
    .num {
      margin-right: 16px;
    }
    .status {
      padding: 2px 12px;
      border-radius: 8px;
      font-size: 22px;
    }
    .status-0 {
      color: #e0632d;
      background: #fff1e8;
    }
    .status-1 {
      color: #23a06b;
      background: #e8f7f0;
    }
    .status-2 {
      color: #d94040;
      background: #fdeced;
    }
    .status-3 {
      color: #3d7eff;
      background: #ebf1ff;
    }
    .btn {
      flex: none;
      min-width: 152px;
      height: 60px;
      padding: 0 20px;
      border-radius: 30px;
      font-size: 24px;
    }
    .btn-primary {
      border: none;
      background: linear-gradient(90deg, #ff7a59 0%, #e04242 100%);
      color: #fff;
      &:disabled {
        opacity: 0.6;
      }
    }
    .btn-plain {
      border: 1px solid #d3d7e0;
      background: transparent;
      color: #5b6478;
    }
    .btn-disabled {
      border: none;
      background: #eef0f5;
      color: #a5abb9;
    }
  }
  .empty {
    padding: 120px 0;
    text-align: center;
    color: #a5abb9;
    .van-icon {
      font-size: 96px;
    }
    p {
      margin-top: 24px;
      font-size: 28px;
    }
  }
  .van-list__finished-text, .van-list__loading-text {
    font-size: 24px;
  }
}
</style>
